import { apiBaseURL, apiLoginURL } from "../Utils/ProjectConstants";
import { Link, useNavigate } from "react-router-dom";

export default function useAuth() {
  const navigate = useNavigate();
  //console.log(localStorage)
  const loginWA = async () => {
    let success = false,
      errors = [],
      user = null;

    await fetch("https://atlasboardwa/api/account/login", {
      method: "GET",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Credentials": true,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status === 200) {
          console.log("logging in");
          return res.json();
        } else if (res.status === 401) {
          console.log("unauthorized");
        }
      })
      .then((json) => {
        if (json.statusCode) {
          success = true;
          user = {
            name: json.data.firstName,
            id: json.data.id,
            roles: json.data.roles,
            new: false,
            email: json.data.email,
            activeCenter: json.data.activeCenter,
            WAauth: true,
          };
          localStorage.setItem(
            "token",
            JSON.stringify({
              token: json.data.token,
              tokenExpiration: json.data.expiration,
            })
          );

          localStorage.setItem("user", JSON.stringify(user));
        } else {
          console.log("statusCode: false");
        }
      })
      .catch((e) => {
        console.log("error");
        errors = [
          {
            isMessageInGDStanding: false,
            message: `An error has occured. Please try again later. ${e}`,
          },
        ];
      });

    return { errors, success, user };
  };

  const login = async (email, password) => {
    let success = false,
      errors = [],
      user = null;

    await fetch(`${apiBaseURL}/api/account/login`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Credentials": true,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.result.statusCode) {
          success = true;
          user = {
            name: json.firstName,
            id: json.id,
            roles: json.roles,
            new: json.isNewUser,
            email: json.email,
            activeCenter: json.activeCenter,
            WAauth: false,
          };

          localStorage.setItem(
            "token",
            JSON.stringify({
              token: json.result.messeges[1],
              tokenExpiration: json.result.messeges[0],
            })
          );

          localStorage.setItem("user", JSON.stringify(user));
        } else {
          if (Array.isArray(json.result.messeges)) {
            errors = json.result.messeges.map((message) => ({
              isMessageInGDStanding: false,
              message,
            }));
          } else {
            const arr =
              json.errors &&
              Object.keys(json.errors).map((key) => json.errors[key]);
            const notifArr = json.errors && [].concat.apply([], arr);

            errors = json.errors
              ? notifArr.map((message) => ({
                  isMessageInGDStanding: false,
                  message,
                }))
              : [
                  {
                    isMessageInGDStanding: false,
                    message: "An error has occured. Please try again later.",
                  },
                ];
          }
        }
      })
      .catch((e) => {
        errors = [
          {
            isMessageInGDStanding: false,
            message: `An error has occured. Please try again later. ${e}`,
          },
        ];
      });

    return { errors, success, user };
  };

  const logout = () => {
    localStorage.clear();
    //localStorage.removeItem('token');
    //localStorage.removeItem('user');
    //localStorage.removeItem('logout');
    //localStorage.setItem('logout', true);
    navigate("/login");
  };

  // Refresh token for persisting session
  //const { data, error, isValidating } = useSWR(
  //    isLogin ? `${apiBaseURL}/api/AuthManagement/RefreshToken` : null,
  //    url =>
  //        fetch(url, {
  //            credentials: 'include',
  //        }).then(res => res.json()),
  //    {
  //        // Silently refresh token every expiry time
  //        refreshInterval: 1000 * 60 * 15,
  //        revalidateOnFocus: false
  //    }
  //);

  //useEffect(() => {
  //    if (data) {
  //        login(data.accessToken);
  //    }
  //    if (error) {
  //        logout();
  //    }
  //    setIsLoading(isValidating);
  //}, [data, error, isValidating]);

  const tokenStr = localStorage.getItem("token");
  const userToken = JSON.parse(tokenStr);

  const getToken = () => {
    if (userToken) {
      const expire = new Date(userToken.tokenExpiration);
      const currentDate = new Date();

      if (currentDate < expire) {
        return userToken.token;
      }

      logout();
      return null;
    }

    return null;
  };

  return {
    token: getToken(),
    refreshToken: userToken?.refreshToken,
    tokenExpiration: userToken?.tokenExpiration,
    isLogin: userToken ? true : false,
    login,
    loginWA,
    logout,
  };
}
